import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainer,
  rendezVousChoiceTypeContainer,
  rendezVousCheckbox,
  rendezVousLoadingWrapper,
  rendezVousLoadingSpinner,
  checkIcon,
  spanContainer,
} from "./rendez-vous-part-1.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousInputType,
} from "../rendez-vous-styled.js"
import loadingGif from "../../../images/loading.gif"

export const RendezVousPart1 = ({
  sortedTypesRendezVousData,
  changeType,
  typeChoisi,
}) => {
  return (
    <RendezVousSubContainer className={rendezVousSubContainer}>
      <RendezVousTitle className={rendezVousTitle} id={"rdv_part1_title"}>
        Choix du type de rendez-vous
      </RendezVousTitle>
      <div
        className={rendezVousChoiceTypeContainer}
        aria-labelledby={"rdv_part1_title"}
        role={"radiogroup"}
      >
        {!sortedTypesRendezVousData.length && (
          <div className={rendezVousLoadingWrapper}>
            <img
              alt="loading gif"
              src={loadingGif}
              className={rendezVousLoadingSpinner}
            />
            <span>Chargement des données...</span>
          </div>
        )}
        {sortedTypesRendezVousData &&
          Object.keys(sortedTypesRendezVousData).map((key, index) => (
            <div key={index}>
              <label
                htmlFor={sortedTypesRendezVousData[key].id}
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    changeType(sortedTypesRendezVousData[key].id)
                  }
                }}
              >
                <RendezVousInputType
                  type="radio"
                  className={rendezVousCheckbox}
                  value={sortedTypesRendezVousData[key].id}
                  checked={
                    parseInt(sortedTypesRendezVousData[key].id) ===
                    parseInt(typeChoisi)
                  }
                  name="choixType"
                  id={sortedTypesRendezVousData[key].id}
                  onClick={() => changeType(sortedTypesRendezVousData[key].id)}
                  tabIndex="-1"
                />{" "}
                <div className={spanContainer}>
                  <span className={checkIcon} aria-hidden={true}></span>
                  <span> {sortedTypesRendezVousData[key].libelle}</span>
                </div>
              </label>
            </div>
          ))}
      </div>
    </RendezVousSubContainer>
  )
}

RendezVousPart1.propTypes = {
  sortedTypesRendezVousData: PropTypes.array,
  changeType: PropTypes.func,
  typeChoisi: PropTypes.number,
}
